import { ResponsivePie } from '@nivo/pie'

const PiaCharts1 = ({ selectedBuilding, piechartdata }) => {
    return (
        <>
            <ResponsivePie
                data={piechartdata}
                margin={{ top: 40, right: 80, bottom: 80, left: 80 }}
                padAngle={0.7}
                cornerRadius={3}
                activeOuterRadiusOffset={8}
                borderWidth={2}
                colors={{ scheme: 'category10' }}
                borderColor="#ffffff"
                arcLinkLabelsSkipAngle={10}
                arcLinkLabelsTextColor="#333333"
                arcLinkLabelsThickness={2}
                arcLinkLabelsDiagonalLength={10}
                arcLinkLabelsStraightLength={10}
                arcLinkLabelsColor={{ from: 'color' }}
                arcLabelsSkipAngle={10}
                arcLabelsTextColor="white"
                tooltip={({ datum: { id, value, color } }) => (
                    <div
                        className="bg-white px-4 py-2 d-flex align-items-center justify-content-between gap-2 rounded"
                    >
                        <div className='' style={{ width: '15px', height: '15px', background: color }}></div>
                        <strong className='fs-4 title-font-600'>
                            {id}: {value}
                        </strong>
                    </div>
                )}
                theme={{
                    fontSize: 13,
                    fontFamily: 'Poppins',
                    fontWeight: "700",
                    tooltip: {
                        container: {
                            background: '#fff',
                        },
                    },
                }}
                animate={false}
            />
        </>
    )
}
export default PiaCharts1
